(function () {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 992px)');
  var active = false;
  var observer = null;
  var enhancementFrame = null;
  var statusTimer = null;
  var idCounter = 0;
  var attributeChanges = [];
  var attributeRegistry = new WeakMap();

  function rememberAttribute(element, name, value) {
    if (!element) return;

    var names = attributeRegistry.get(element);
    if (!names) {
      names = {};
      attributeRegistry.set(element, names);
    }

    if (!names[name]) {
      names[name] = true;
      attributeChanges.push({
        element: element,
        name: name,
        existed: element.hasAttribute(name),
        value: element.getAttribute(name)
      });
    }

    element.setAttribute(name, value);
  }

  function createElement(tagName, className) {
    var element = document.createElement(tagName);
    element.className = className;
    element.setAttribute('data-jillleen-created', 'true');
    return element;
  }

  function nextId(prefix) {
    idCounter += 1;
    return prefix + '-' + idCounter;
  }

  function itemName(element) {
    var item = element.closest('.cart-product-item, .mini-products-list .item, .cart-list > li');
    var name = item ? item.querySelector('.product-name') : null;
    return name && name.textContent.trim() ? name.textContent.trim() : 'Item';
  }

  function checkoutZone(root) {
    if (root.id === 'dropdown-cart') {
      return root.querySelector('.has-items .actions');
    }
    return root.querySelector('.grouped-bottom .btn-actions');
  }

  function ensureCheckoutMessage(root) {
    var zone = checkoutZone(root);
    if (!zone) return;

    var assurance = root.querySelector('.jillleen-checkout-assurance');
    if (!assurance) {
      assurance = createElement('div', 'jillleen-checkout-assurance');
      assurance.id = nextId('jillleen-cart-assurance');
      assurance.innerHTML =
        '<p class="jillleen-checkout-assurance__title">Order review</p>' +
        '<p class="jillleen-checkout-assurance__copy">Shipping, taxes, and discounts are shown before you place your order.</p>';
      zone.parentNode.insertBefore(assurance, zone);
    }

    var status = root.querySelector('.jillleen-cart-status');
    if (!status) {
      status = createElement('div', 'jillleen-cart-status');
      status.id = nextId('jillleen-cart-status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      assurance.insertAdjacentElement('afterend', status);
    }

    root.querySelectorAll('.btn-checkout, [name="checkout"]').forEach(function (checkout) {
      var describedBy = [checkout.getAttribute('aria-describedby'), assurance.id, status.id]
        .filter(Boolean)
        .join(' ');
      rememberAttribute(checkout, 'aria-describedby', describedBy);
    });
  }

  function cartStatus(root) {
    ensureCheckoutMessage(root);
    return root.querySelector('.jillleen-cart-status');
  }

  function announce(root, message) {
    var status = cartStatus(root);
    if (!status) return;

    window.clearTimeout(statusTimer);
    status.textContent = '';
    window.requestAnimationFrame(function () {
      status.textContent = message;
    });
    statusTimer = window.setTimeout(function () {
      if (status.isConnected) status.textContent = '';
    }, 6000);
  }

  function quantityBounds(input) {
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max') || input.getAttribute('data-line'), 10);
    return {
      min: Number.isFinite(min) ? min : 1,
      max: Number.isFinite(max) && max > 0 ? max : null
    };
  }

  function updateQuantityButtons(shell) {
    var input = shell.querySelector('input');
    var minus = shell.querySelector('[data-jillleen-qty-step="-1"]');
    var plus = shell.querySelector('[data-jillleen-qty-step="1"]');
    var bounds = quantityBounds(input);
    var value = parseInt(input.value, 10);

    value = Number.isFinite(value) ? value : bounds.min;
    minus.disabled = input.disabled || value <= bounds.min;
    plus.disabled = input.disabled || (bounds.max !== null && value >= bounds.max);
  }

  function quantityButton(direction, name) {
    var button = createElement('button', 'jillleen-qty-step');
    button.type = 'button';
    button.textContent = direction < 0 ? '-' : '+';
    button.setAttribute('data-jillleen-qty-step', String(direction));
    button.setAttribute('aria-label', (direction < 0 ? 'Decrease quantity for ' : 'Increase quantity for ') + name);
    return button;
  }

  function enhanceQuantity(input) {
    if (input.closest('.jillleen-qty-shell')) return;

    var name = itemName(input);
    var shell = createElement('div', 'jillleen-qty-shell');
    var minus = quantityButton(-1, name);
    var plus = quantityButton(1, name);

    rememberAttribute(input, 'aria-label', 'Quantity for ' + name);
    rememberAttribute(input, 'inputmode', 'numeric');

    input.parentNode.insertBefore(shell, input);
    shell.appendChild(minus);
    shell.appendChild(input);
    shell.appendChild(plus);
    updateQuantityButtons(shell);
  }

  function enhanceRemoveLinks(root) {
    root.querySelectorAll('a.remove, a.btn-remove, .cart-remove a').forEach(function (link) {
      var name = itemName(link);
      rememberAttribute(link, 'aria-label', 'Remove ' + name + ' from cart');

      if (root.id !== 'dropdown-cart' && !link.querySelector('.jillleen-remove-label')) {
        var label = createElement('span', 'jillleen-remove-label');
        label.textContent = 'Remove';
        link.appendChild(label);
      }
    });
  }

  function enhanceEditLinks(root) {
    root.querySelectorAll('[data-cart-edit]').forEach(function (link) {
      rememberAttribute(link, 'aria-label', 'Edit options for ' + itemName(link));
    });
  }

  function enhanceDiscountField(root) {
    var input = root.querySelector('.discount-code-field input[name="discount"]');
    if (!input) return;

    rememberAttribute(input, 'id', 'discount');
    rememberAttribute(input, 'aria-label', 'Discount code');

    var help = input.parentNode.querySelector('p');
    if (help) {
      if (!help.id) rememberAttribute(help, 'id', nextId('jillleen-discount-help'));
      rememberAttribute(input, 'aria-describedby', help.id);
    }
  }

  function enhanceEmptyState(root) {
    var empty = root.querySelector(root.id === 'dropdown-cart' ? '.no-items' : '.no-item-cart');
    if (!empty) return;
    rememberAttribute(empty, 'role', 'region');
    rememberAttribute(empty, 'aria-label', 'Empty cart');
  }

  function enhanceDrawer(root) {
    if (root.id !== 'dropdown-cart') return;

    var heading = root.querySelector('.cart-title h5');
    if (heading) {
      if (!heading.id) rememberAttribute(heading, 'id', nextId('jillleen-cart-title'));
      rememberAttribute(root, 'role', 'dialog');
      rememberAttribute(root, 'aria-modal', 'true');
      rememberAttribute(root, 'aria-labelledby', heading.id);
    }

    var close = root.querySelector('.close-cart');
    if (close) rememberAttribute(close, 'aria-label', 'Close cart');
  }

  function enhanceRoot(root) {
    root.classList.add('jillleen-cart-enhanced');
    ensureCheckoutMessage(root);
    enhanceRemoveLinks(root);
    enhanceEditLinks(root);
    enhanceDiscountField(root);
    enhanceEmptyState(root);
    enhanceDrawer(root);

    root
      .querySelectorAll('.wrapper-cart-template input.update-cart--template, input.item-quantity')
      .forEach(enhanceQuantity);
  }

  function enhanceAll() {
    if (!active || !desktopQuery.matches) return;
    document.querySelectorAll('.cart-template, #dropdown-cart').forEach(enhanceRoot);
  }

  function scheduleEnhancement() {
    if (!active || enhancementFrame !== null) return;
    enhancementFrame = window.requestAnimationFrame(function () {
      enhancementFrame = null;
      enhanceAll();
    });
  }

  function restoreAttributes() {
    for (var index = attributeChanges.length - 1; index >= 0; index -= 1) {
      var change = attributeChanges[index];
      if (!change.element.isConnected) continue;
      if (change.existed) {
        change.element.setAttribute(change.name, change.value);
      } else {
        change.element.removeAttribute(change.name);
      }
    }
    attributeChanges = [];
    attributeRegistry = new WeakMap();
  }

  function deactivate() {
    if (!active) return;
    active = false;

    if (observer) observer.disconnect();
    if (enhancementFrame !== null) window.cancelAnimationFrame(enhancementFrame);
    window.clearTimeout(statusTimer);
    enhancementFrame = null;

    document.querySelectorAll('.jillleen-qty-shell[data-jillleen-created="true"]').forEach(function (shell) {
      var input = shell.querySelector('input');
      if (input && shell.parentNode) shell.parentNode.insertBefore(input, shell);
      shell.remove();
    });

    document.querySelectorAll('[data-jillleen-created="true"]').forEach(function (element) {
      element.remove();
    });
    document.querySelectorAll('.jillleen-cart-enhanced').forEach(function (root) {
      root.classList.remove('jillleen-cart-enhanced');
    });
    document.documentElement.classList.remove('jillleen-cart-desktop-ready');
    restoreAttributes();
  }

  function activate() {
    if (active || !desktopQuery.matches) return;
    active = true;
    document.documentElement.classList.add('jillleen-cart-desktop-ready');
    enhanceAll();

    observer = new MutationObserver(scheduleEnhancement);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    if (!active || !desktopQuery.matches) return;

    var step = event.target.closest('[data-jillleen-qty-step]');
    if (step) {
      event.preventDefault();
      if (step.disabled) return;

      var shell = step.closest('.jillleen-qty-shell');
      var input = shell.querySelector('input');
      var bounds = quantityBounds(input);
      var current = parseInt(input.value, 10);
      var direction = parseInt(step.getAttribute('data-jillleen-qty-step'), 10);
      var next = (Number.isFinite(current) ? current : bounds.min) + direction;

      next = Math.max(bounds.min, next);
      if (bounds.max !== null) next = Math.min(bounds.max, next);
      input.value = next;
      updateQuantityButtons(shell);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = event.target.closest('a.remove, a.btn-remove, .cart-remove a');
    if (remove) {
      var root = remove.closest('.cart-template, #dropdown-cart');
      if (root) announce(root, 'Removing ' + itemName(remove) + ' from your cart.');
    }
  });

  document.addEventListener('change', function (event) {
    if (!active || !desktopQuery.matches || !event.target.matches('input.update-cart--template, input.item-quantity')) return;

    var input = event.target;
    var shell = input.closest('.jillleen-qty-shell');
    var root = input.closest('.cart-template, #dropdown-cart');
    if (shell) updateQuantityButtons(shell);
    if (root) announce(root, itemName(input) + ' quantity changed to ' + input.value + '.');
  });

  function handleBreakpoint(event) {
    if (event.matches) activate();
    else deactivate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate, { once: true });
  } else {
    activate();
  }

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', handleBreakpoint);
  } else {
    desktopQuery.addListener(handleBreakpoint);
  }
})();
